/**
 * Auto Dead Click — 죽은 클릭 감지
 * 클릭 후 1초간 MutationObserver로 DOM 변화 감시
 * DOM 변화 없고 + 클릭 요소가 interactive → Dead Click
 * MutationObserver는 1초 후 즉시 disconnect (메모리 누수 방지)
 */

import { getElementText } from "./utils";

var INTERACTIVE_SELECTOR = 'button, a, [role="button"], input[type="submit"], [onclick]';
var OBSERVE_DURATION = 1000; // 1초

export function initDeadClick(mixpanel) {
  // 동시에 여러 observer가 돌지 않도록 제한
  var activeObservers = 0;
  var MAX_OBSERVERS = 3;

  function handler(event) {
    try {
      var target = event.target;
      if (!target || typeof target.closest !== "function") return;

      var interactive = target.closest(INTERACTIVE_SELECTOR);
      if (!interactive) return; // interactive 요소가 아닌 곳 클릭은 무시

      // observer 개수 제한
      if (activeObservers >= MAX_OBSERVERS) return;

      var domChanged = false;
      activeObservers++;

      var observer = new MutationObserver(function () {
        domChanged = true;
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      // 1초 후 확인
      setTimeout(function () {
        try {
          observer.disconnect();
          activeObservers--;

          if (!domChanged) {
            var trackFn = function () {
              try {
                mixpanel.track("Auto Dead Click", {
                  element_tag: interactive.tagName ? interactive.tagName.toLowerCase() : "",
                  element_text: getElementText(interactive),
                  route_path: window.location.pathname,
                });
              } catch (e) {
                // 무시
              }
            };

            if (typeof requestIdleCallback === "function") {
              requestIdleCallback(trackFn);
            } else {
              setTimeout(trackFn, 0);
            }
          }
        } catch (e) {
          activeObservers = Math.max(0, activeObservers - 1);
          try {
            observer.disconnect();
          } catch (e2) {
            /* 무시 */
          }
        }
      }, OBSERVE_DURATION);
    } catch (e) {
      // 핸들러 에러가 서비스로 전파되지 않도록
    }
  }

  document.addEventListener("click", handler, { passive: true, capture: true });
}
